import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';

interface ProductWithPrepayments {
    firstPaymentDefinitions?: IFirstPaymentDefinition[];
}

export default function getPrepaymentsList<T extends ProductWithPrepayments>(
    products: T[],
): IFirstPaymentDefinition[] {
    if (!products || !products.length) return [];

    const seenParts = new Set<number>();
    const uniquePrepayments: IFirstPaymentDefinition[] = [];

    products.forEach((product) => {
        const firstPaymentDefinitions = product.firstPaymentDefinitions;
        if (firstPaymentDefinitions && firstPaymentDefinitions.length) {
            firstPaymentDefinitions.forEach((fpd) => {
                if (fpd && fpd.firstPaymentPart && !seenParts.has(fpd.firstPaymentPart)) {
                    seenParts.add(fpd.firstPaymentPart);
                    uniquePrepayments.push(fpd);
                }
            });
        }
    });

    return uniquePrepayments.sort((a, b) => a.firstPaymentPart - b.firstPaymentPart);
}
